module.exports = {"411023001":"许由","411023002":"新元","411023100":"将官池镇","411023101":"五女店镇","411023102":"尚集镇","411023103":"苏桥镇","411023104":"蒋李集镇","411023105":"张潘镇","411023106":"灵井镇","411023200":"陈曹乡","411023201":"邓庄乡","411023202":"小召乡","411023203":"河街乡","411023204":"桂村乡","411023205":"椹涧乡","411023206":"榆林乡","411023208":"艾庄回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411023.json
// module id = 1740
// module chunks = 0